import React from 'react';
import { TabNav } from '@bwoty-web/styleguide';
import { formatMessage } from './FormattedMessage';

function ResultNavBar({ changeTab, selectedTab, labels = [], scopedResults }) {
  const allSearchResults = {};
  scopedResults.forEach(({ indexId, results }) => {
    allSearchResults[indexId] = results;
  });
  const filteredLabels = labels.filter(
    (tt) => allSearchResults && allSearchResults[tt.index] && allSearchResults[tt.index].nbHits,
  );
  if (filteredLabels.length < 1) {
    return null;
  }

  const tabs = filteredLabels
    .map((tab) => {
      if (!allSearchResults || !allSearchResults[tab.index]) {
        return null;
      }
      const hitCount = allSearchResults[tab.index]?.nbHits || 0;
      return {
        value: formatMessage({
          text: tab.value,
          values: { nrOfHits: hitCount },
        }),
        disabled: false,
      };
    })
    .filter(Boolean);
  const selectedIndex = filteredLabels.findIndex((t) => t.section === selectedTab);

  return (
    <div className="web-result-nav-bar">
      <TabNav
        onClick={(index) => changeTab(filteredLabels[index].section)}
        selected={selectedIndex !== -1 ? selectedIndex : 0}
        tabs={tabs}
      />
    </div>
  );
}

export default ResultNavBar;
